import { render, staticRenderFns } from "./WorkflowClose.vue?vue&type=template&id=1aaebddd&"
import script from "./WorkflowClose.vue?vue&type=script&lang=js&"
export * from "./WorkflowClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports